import { createApp } from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './routes';
import './assets/css/main.css';

// A 401 means the super_admin_token is missing/invalid/expired — every
// component here calls axios directly (no shared instance), so this global
// interceptor is the one place that catches it regardless of which page or
// component made the request, and sends the user straight to the login
// screen instead of leaving a broken page behind an "Unauthorized" alert.
// A full reload (not router.push) is used deliberately: HomeEntry.vue's
// isAuthenticated is a one-time ref set at mount, not reactive to
// localStorage — pushing to '/' while already there wouldn't remount it and
// the broken layout would stay on screen even with the token gone.
//
// IMPORTANT: some endpoints proxy to an EXTERNAL provider (e.g. the WhatsApp
// integration test/send routes). A 401 from those is the provider's auth
// failing, NOT our session expiring — logging the admin out there is wrong.
// Those paths are exempted so their 401 surfaces as an inline error instead.
const AUTH_401_EXEMPT = ['/whatsapp/'];

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            const url = (error.config && error.config.url) || '';
            const exempt = AUTH_401_EXEMPT.some(p => url.includes(p));
            if (!exempt) {
                localStorage.removeItem('super_admin_token');
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

const app = createApp(App);
app.config.globalProperties.$API_URL = process.env.VUE_APP_API_URL;

app.use(router).mount('#app');
